import { Dispatch, SetStateAction, useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { createWithEqualityFn as create } from 'zustand/traditional';

interface PersistentSearchStore {
    searches: { [key: string]: string };
    setSearchValue: (key: string, value: string) => void;
}

const usePersistentSearchStore = create<PersistentSearchStore>(set => ({
    searches: {},
    setSearchValue: (key, value) =>
        set(state => ({ searches: { ...state.searches, [key]: value } })),
}));

const usePersistentSearch = (customKey?: string): [string, Dispatch<SetStateAction<string>>] => {
    const { pathname } = useLocation();
    const { searches, setSearchValue } = usePersistentSearchStore();
    const key = customKey ?? pathname;
    const savedSearch = searches[key];
    const [localSearch, setLocalSearch] = useState(savedSearch ?? '');
    const localSearchRef = useRef(localSearch);

    useEffect(() => {
        localSearchRef.current = localSearch;
    }, [localSearch]);

    useEffect(() => {
        return () => {
            setSearchValue(key, localSearchRef.current);
        };
    }, [key, setSearchValue]);

    return [localSearch, setLocalSearch];
};

export { usePersistentSearch };
